
let React = require("react");
let AssetInfo =           require("../../controls/AssetInfo.jsx");
let Loading =             require("../../controls/modals/Loading.jsx");
let LoadingCard =         require("../../controls/cards/LoadingPlaceholder.jsx");

let ContentServerClient = require("../../ContentServerClient.js");
let ApplicationContext =  require("../../config/ApplicationContext.js");
let ObservableUtil =      require("../../util/ObservableUtil.js");

let LoginUtil =           require("../../util/LoginUtil.js");
let HubsUtil =           require("../../util/HubsUtil.js");

class AssetDetail extends React.Component {

    constructor(props) {
        super(props);

        this.state = { resource: false, modelData: {}, error: {}, hub: null, typeUser: '' }

        this.onClose = this.onClose.bind(this);
        this.getId = this.getId.bind(this);
    }

    componentDidMount() {
        googleGA("send", "event", `${this.props.displayName} detail`, "pageview");
        document.title = `${this.props.displayName} Detail | library.io`;

        document.body.style.overflow = "hidden";
        let id = this.getId(this.props.match.params.name);

        // need to know entitlements in details pages
        ContentServerClient.loginCheck(()=>{})
            .then(info => {
                this.setState({ typeUser: HubsUtil.typeUser(info.entitlements)})
            });

        LoginUtil.checkLogin(() => {
            this.setInfo(id, ApplicationContext.getUserData())
                .then(res => {
                    // we want to reload the resource if something about it has changed (published or deleted)
                    ObservableUtil.subscribeToChange("delete", id, "assetDetailPage", () => this.onClose())
                    ObservableUtil.subscribeToChange("publish", id, "assetDetailPage", (res) => this.reloadResource(id))
                })
        });
    }

    componentWillUnmount() {
        ObservableUtil.unsubscribeToChange("delete", this.state.resource.id, "assetDetailPage");
        ObservableUtil.unsubscribeToChange("publish", this.state.resource.id, "assetDetailPage");
        document.body.style.overflow = "auto";
    }

    getId(text) {
        if(Number(text)){
            return Number(text);
        }else{
            return text.slice(0, text.indexOf("-"));
        }
    }

    setInfo(assetId, {id: current_user_id} = {id: false}){
        this.setState({ assetId, current_user_id });

        return ContentServerClient.getFile(this.props.handleError, `${this.props.urlName}/${assetId}`)
                    .then(resource => this.checkUrl(resource))
                    .then(resource => {
                        if(this.validateItem(resource)){
                            this.setState({ resource });
                            return resource;
                        }
                    })
                    .then((res)=>{
                        if(current_user_id == res.user_id){
                            return ContentServerClient.getHub(this.props.handleError, res.hub)
                            .then(hub => {
                                this.setState({hub});
                            });
                        }
                    })
                    //In order to avoid problems the user must get back to the start pages
                    .catch(this.onClose)
    }


    reloadResource(assetId){
        return ContentServerClient.getFile(this.props.handleError, `/${this.props.urlName}/${assetId}`)
                .then(resource => this.setState({ resource }))
    }

    checkUrl(resource){
        const { history, location: {pathname}, urlName} = this.props;
        let {id, name} = resource;
        name = this.formatName(name);

        if(pathname !== `/${urlName}/${id}-${name}`){
            history.replace({pathname: `/${urlName}/${id}-${name}`});
        }
        return resource;
    }

    formatName(name){
        return name.replace(/ /g,"-").replace("/","%2F");
    }

    onClose(){
        const {history, urlName, location} = this.props;
        const {user_id, hub: idHub, hub_name} = this.state.resource;

        if(location.state && location.state.previousView){
            history.push(location.state.previousView)
        }
        else if(this.state.current_user_id === user_id){
            history.push(`/hubs/${idHub}-${encodeURIComponent(hub_name)}/${urlName}`)
        }
        else{
            history.push(`/search/${urlName}`)
        }
    }

    validateItem(resource = false){
        if(resource){
            return true;
        }else{
            this.props.history.push(`/pageNotFound`);
            return false;
        }
    }

    render() {
        let styleInline = {alignItems: "flex-start" , overflow: "auto"};
        const { Preview, className} = this.props;
        const { resource } = this.state;

        if(!resource){
            return <Loading show={true}> <LoadingCard/> </Loading>
        }

        return <Loading show={true} style={styleInline} hasClose={true} onClose={this.onClose}>
                    <div className={`detail ${className}`}>

                        <Preview
                            {...this.props}
                            typeUser={this.state.typeUser}
                            resource={resource}
                            setError={this.props.handleError}
                            current_user_id={this.state.current_user_id}
                        />

                        <AssetInfo
                            {...this.props}
                            typeUser={this.state.typeUser}
                            resource={this.state.resource}
                            hub={this.state.hub}
                            current_user_id={this.state.current_user_id}
                        />

                    </div>
                </Loading>
    }
}

module.exports = AssetDetail;
